import React from "react";
import { Button, Space, Tag } from "antd";
import { Link } from "react-router-dom";
import { PlusOutlined, TeamOutlined, UserAddOutlined } from "@ant-design/icons";
import AppLayout from "../components/Layout";
import DataTable from "../components/DataTable";
import SearchBox from "../components/SearchBox";
import usePagedList from "../lib/usePagedList";
import { formatDate } from "../helper";

const Events = () => {
	const list = usePagedList("events");

	const columns = [
		{ title: "Event", dataIndex: "name", key: "name", render: (v, row) => <Link to={`/events/${row.id}/students`}>{v}</Link> },
		{ title: "Date", dataIndex: "start_date", key: "start_date", render: formatDate },
		{
			title: "Contacts",
			dataIndex: "students_count",
			key: "students_count",
			align: "center",
			render: (v) => v || 0,
		},
		{
			title: "Results by scenario",
			dataIndex: "scenarios",
			key: "scenarios",
			width: 400,
			render: (scenarios) =>
				scenarios && Object.keys(scenarios).length ? (
					<Space size={[6, 6]} wrap style={{ maxWidth: 380 }}>
						{Object.entries(scenarios).map(([name, count]) => (
							<Tag key={name} color={count > 0 ? "cyan" : "default"}>
								{name}: {count}
							</Tag>
						))}
					</Space>
				) : (
					"-"
				),
		},
		{
			title: "",
			key: "actions",
			align: "right",
			render: (row) => (
				<Space>
					<Link to={`/event-mode?id=${row.id}&name=${encodeURIComponent(row.name)}`}>
						<Button size="small" icon={<UserAddOutlined />}>
							Add contact
						</Button>
					</Link>
					<Link to={`/events/${row.id}/students`}>
						<Button type="primary" size="small" icon={<TeamOutlined />}>
							Contacts
						</Button>
					</Link>
				</Space>
			),
		},
	];

	return (
		<AppLayout
			title="Events"
			subtitle="Training sessions with their own group of contacts."
			actions={
				<>
					<SearchBox onSearch={list.onSearch} placeholder="Search events" />
					<Link to="/events/create">
						<Button type="primary" size="large" icon={<PlusOutlined />}>
							Add event
						</Button>
					</Link>
				</>
			}
		>
			<DataTable rows={list.rows} columns={columns} loading={list.loading} pagination={list.pagination} />
		</AppLayout>
	);
};

export default Events;
